
import { Br, Cut, Line, Printer, Text, Row, render, Image, QRCode } from 'react-thermal-printer';
import { currencyFormatPrint } from './formatCurrency';
import { dateFormat } from './formatDate';
import { posPriceBeforeDiscount, posPriceBeforeDiscountNum, posPriceDiscountPercent, posPriceDiscountPrice, posPriceNum } from './POS/posPrice';
import { textPaper } from './Print/printText';
import { formatNumber } from './formatNumber';

const bonusPCS = (item) => {
    var total_qty = item.qty;
    var qty_bonus = total_qty / 2;
    var qty_now = item.bonus.bonus_product.qty * qty_bonus;
    return Math.floor(qty_now);
}

const textRight = (text) => {
    var n = text.substring(0, 20);
    return n;
}

const jml_paper = 32;
export const writePrint = async (serialPort, ev) => {
    var date = new Date();
    var dateTime = dateFormat(date);
    var customer = ev.customer !== undefined && ev.customer !== null ? ev.customer.name : 'Non Membership';
    var total_disc_price = 0;

    const receipt = (
        <Printer type="epson" width={jml_paper}>
            <Image align="center" src={ev.outlet.image != null ? ev.outlet.image : "assets/bolde2.png"} />
            <Text align="center">PT. BOLDE INOVASI GLOBAL</Text>
            <Text align="center">Komp Taman Palem Lestari J/28A, Cengkareng, Jakarta Barat</Text>
            <Text align="center">NPWP : 02.456.139.1-034.000</Text>
            <Br />
            <Text size={{ width: 1, height: 1 }} bold={true} align="center">{textPaper(ev.outlet.outlet_name, jml_paper)}</Text>
            <Text align="center">{ev.outlet.address !== "" && ev.outlet.address !== null ? textPaper(ev.outlet.address, jml_paper) : "Komp Era Prima No G1 Jl Daan Mogot KM 21, Tangerang"}</Text>
            <Text bold={true} align="center">{ev.transaction_code}</Text>
            <Br />

            {ev.data.is_ecommerce !== undefined && ev.data.is_ecommerce === true ? (
                <>
                    <Line />
                    <Text align="center">E-Commerce</Text>
                    <Line />
                </>
            ) : (
                <Line />
            )}

            <Row left="Kasir     : " right={textRight(ev.cashier.detail_user.first_name + ' ' + ev.cashier.detail_user.last_name)} />
            <Row left="Transaksi : " right={dateTime} />
            <Row left="Pelanggan : " right={textRight(customer)} />
            <Line />

            {ev.product.map((key, i) => {
                const isMinPurchase = key.is_min_purchase === true;
                const isClearance = key.is_clearance === true;

                var price = isMinPurchase
                    ? Number(key.price || 0)
                    : isClearance
                        ? Number(key.price_clearance || key.edit_price || key.price || 0)
                        : posPriceNum(key, ev.data.is_ecommerce);

                var price_normal = isMinPurchase
                    ? Number(key.price || 0)
                    : isClearance
                        ? Number(key.price_clearance || key.edit_price || key.price || 0)
                        : posPriceBeforeDiscountNum(key);

                var discount_percent = isMinPurchase || isClearance
                    ? null
                    : posPriceDiscountPercent(key, ev.data.is_ecommerce);

                var discount_price = isMinPurchase || isClearance
                    ? 0
                    : Number(posPriceDiscountPrice(key, ev.data.is_ecommerce));

                var subtotal = Number(price) * Number(key.qty || 1);

                if (!isMinPurchase && !isClearance && key.edit_price !== undefined) {
                    price = key.edit_price;
                    discount_percent = key.edit_discount_percent;
                    discount_price = key.edit_discount_price;
                    subtotal = (Number(price) + Number(discount_price)) * key.qty;
                }

                total_disc_price += Number(discount_price || 0) * Number(key.qty || 1);

                var productName =
                    (key.product?.product_name || key.product_name || '-') +
                    ' ' +
                    (key.variant_product?.variant_name || key.variant_name || '');

                return (
                    <div key={i}>
                        {isMinPurchase ? (
                            <>
                                <Text bold={true}>
                                    {textPaper('(Tebus Murah) ' + productName, jml_paper)}
                                </Text>
                                <Row
                                    left={
                                        (key.qty || 1) +
                                        (key.product?.product_satuans?.length > 0 ? key.product.product_satuans[0].satuan : 'pcs') +
                                        " x " +
                                        currencyFormatPrint(price)
                                    }
                                    right={currencyFormatPrint(subtotal)}
                                />
                            </>
                        ) : isClearance ? (
                            <>
                                <Text bold={true}>
                                    {textPaper('(Clearance) ' + productName, jml_paper)};
                                </Text>
                                <Row
                                    left={
                                        (key.qty || 1) +
                                        (key.product?.product_satuans?.length > 0 ? key.product.product_satuans[0].satuan : 'pcs') +
                                        " x " +
                                        currencyFormatPrint(price)
                                    }
                                    right={currencyFormatPrint(subtotal)}
                                />
                            </>
                        ) : (
                            key.status_bonus !== undefined && key.status_bonus !== null ? (
                                key.status_bonus === true ? (
                                    <>
                                        <Text bold={true}>
                                            {'(Bonus) ' + key.product.product_name + ' ' + (key.variant_name != null ? key.variant_product.variant_name : '')}
                                        </Text>
                                        <Row
                                            left={
                                                key.qty +
                                                (key.product.product_satuans.length > 0 ? key.product.product_satuans[0].satuan : '') +
                                                " x " +
                                                currencyFormatPrint(0)
                                            }
                                            right={currencyFormatPrint(0)}
                                        />
                                    </>
                                ) : null
                            ) : (
                                <>
                                    <Text bold={true}>{textPaper(productName, jml_paper)}</Text>
                                    <Row
                                        left={
                                            key.qty +
                                            (key.product.product_satuans.length > 0 ? key.product.product_satuans[0].satuan : '') +
                                            " x " +
                                            currencyFormatPrint(price_normal)
                                        }
                                        right={currencyFormatPrint(subtotal)}
                                    />
                                    {discount_price > 0 && (
                                        <Row
                                            left="Diskon"
                                            right={currencyFormatPrint(discount_price) + '(' + discount_percent + '%)'}
                                        />
                                    )}

                                    {key.bonus !== undefined && key.bonus !== null ? (
                                        key.qty >= key.bonus.min_order ? (
                                            key.bonus.bonus_product !== null ? (
                                                <>
                                                    <Text bold={true}>
                                                        {'(Bonus) ' + key.bonus.bonus_product.variant_product.product.product_name + ' ' + key.bonus.bonus_product.variant_product.variant_name}
                                                    </Text>
                                                    <Row
                                                        left={
                                                            bonusPCS(key) +
                                                            (key.bonus.bonus_product.variant_product.product.product_satuan !== null ? key.bonus.bonus_product.variant_product.product.product_satuan.satuan : '') +
                                                            " x " +
                                                            currencyFormatPrint(0)
                                                        }
                                                        right={currencyFormatPrint(0)}
                                                    />
                                                </>
                                            ) : null
                                        ) : null
                                    ) : null}
                                </>
                            )
                        )}

                        {ev.product.length < (i + 1) && <Br />}
                    </div>
                );
            })}

            <Line />
            <Text size={{ width: 1.1, height: 1.1 }} bold={true} align="right">
                Total : {currencyFormatPrint(Number(ev.data.grand_total))}
            </Text>
            <Text bold={true} align="right">+ Termasuk Pajak</Text>
            <Line />
            <Text size={{ width: 1, height: 1 }} bold={true} align="center">
                ANDA HEMAT {currencyFormatPrint(total_disc_price)}
            </Text>
            <Line />

            {ev.data.payment_method === 'tunai' ? (
                <Row left="TUNAI : " right={currencyFormatPrint(ev.data.payment)} />
            ) : ev.data.payment_method === 'tunai_point' || ev.data.payment_method === 'point' ? (
                <>
                    <Row left="POINT : " right={"-" + currencyFormatPrint(ev.data.point_redeem)} />
                    <Row left="TUNAI : " right={currencyFormatPrint(ev.data.payment)} />
                </>
            ) : ev.data.payment_method === 'card_point' ? (
                <>
                    <Row left="POINT : " right={"-" + currencyFormatPrint(ev.data.point_redeem)} />
                    <Row left={ev.data.payment_name + ' :'} right={currencyFormatPrint(ev.data.payment)} />
                </>
            ) : (
                <Row left={ev.data.payment_name + ' :'} right={currencyFormatPrint(ev.data.grand_total)} />
            )}

            {ev.data.voucher_price !== null && ev.data.voucher_price !== 0 ? (
                <Row left={'Voucher :'} right={currencyFormatPrint(ev.data.voucher_price)} />
            ) : null}

            <Line />
            <Row left="Kembali : " right={currencyFormatPrint(ev.data.cashback)} />
            <Line />
            <Row left="DPP : " right={currencyFormatPrint((ev.data.grand_total / 1.11))} />
            <Row left="Tax : " right={currencyFormatPrint(((ev.data.grand_total / 1.11) * 0.11))} />
            <Line />
            <Text align="center">Barang yang sudah dibeli tidak</Text>
            <Text align="center">bisa ditukar / dikembalikan</Text>
            <Line />
            <Text align="center">Website : www.boldestore.com</Text>
            <Line />

            {ev.transaction.code_draw !== null && (
                <div>
                    <Text bold={true} align="center">KODE UNDIAN</Text>
                    <QRCode align="center" content={ev.transaction.link_qrcode} model="model2" cellSize={8} correction="L" />
                    <Br />
                    <Text align="center">{ev.transaction.code_draw}</Text>
                </div>
            )}
            <Line />
            <Text align="center">Tukarkan : spin.boldestore.com</Text>
            <Line />

            <Cut />
        </Printer>
    );

    const data = await render(receipt);
    const w = serialPort.writable?.getWriter();

    if (w != null) {
        await w.write(data);
        w.releaseLock();
    }
};

export const writePrintTry = async (serialPort, ev) => {
    var date = new Date();
    var dateTime = dateFormat(date);
    var customer = ev.customer !== undefined && ev.customer !== null ? ev.customer.name : 'Non Membership';
    var total_disc_price = 0;

    const receipt = (
        <Printer type="epson" width={jml_paper}>
            <Image align="center" src={ev.outlet.image != null ? ev.outlet.image : "assets/bolde2.png"} />
            <Text align="center">PT. BOLDE INOVASI GLOBAL</Text>
            <Text align="center">Komp Taman Palem Lestari J/28A, Cengkareng, Jakarta Barat</Text>
            <Text align="center">NPWP : 02.456.139.1-034.000</Text>
            <Br />
            <Text size={{ width: 1, height: 1 }} bold={true} align="center">{textPaper(ev.outlet.outlet_name, jml_paper)}</Text>
            <Text align="center">{ev.outlet.address !== "" && ev.outlet.address !== null ? textPaper(ev.outlet.address, jml_paper) : "Komp Era Prima No G1 Jl Daan Mogot KM 21, Tangerang"}</Text>
            <Text bold={true} align="center">{ev.transaction_code}</Text>
            <Br />

            {ev.data.is_ecommerce !== undefined && ev.data.is_ecommerce === true ? (
                <>
                    <Line />
                    <Text align="center">E-Commerce</Text>
                    <Line />
                </>
            ) : (
                <Line />
            )}

            <Text align="center">CETAK ULANG</Text>
            <Line />
            <Row left="Kasir     : " right={textRight(ev.cashier.detail_user.first_name + ' ' + ev.cashier.detail_user.last_name)} />
            <Row left="Transaksi : " right={dateTime} />
            <Row left="Pelanggan : " right={textRight(customer)} />
            <Line />

            {ev.product.map((key, i) => {
                const isMinPurchase = key.is_min_purchase === true;
                const isClearance = key.is_clearance === true;

                var price = isMinPurchase
                    ? Number(key.price || 0)
                    : isClearance
                        ? Number(key.price_clearance || key.edit_price || key.price || 0)
                        : posPriceNum(key, ev.data.is_ecommerce);

                var price_normal = isMinPurchase
                    ? Number(key.price || 0)
                    : isClearance
                        ? Number(key.price_clearance || key.edit_price || key.price || 0)
                        : posPriceBeforeDiscountNum(key);

                var discount_percent = (isMinPurchase || isClearance)
                    ? null
                    : posPriceDiscountPercent(key, ev.data.is_ecommerce);

                var discount_price = (isMinPurchase || isClearance)
                    ? 0
                    : Number(posPriceDiscountPrice(key, ev.data.is_ecommerce));

                var subtotal = (isMinPurchase || isClearance)
                    ? Number(price) * Number(key.qty || 1)
                    : (Number(price) + Number(discount_price)) * Number(key.qty || 1);

                if (!isMinPurchase && !isClearance && key.edit_price !== undefined) {
                    price = key.edit_price;
                    discount_percent = key.edit_discount_percent;
                    discount_price = posPriceBeforeDiscountNum(key) - key.edit_price;
                    subtotal = (Number(price) + Number(discount_price)) * Number(key.qty || 1);
                }

                total_disc_price += Number(discount_price || 0) * Number(key.qty || 1);

                var productName =
                    (key.product?.product_name || key.product_name || '-') +
                    ' ' +
                    (key.variant_product?.variant_name || key.variant_name || '');

                return (
                    <div key={i}>
                        {isMinPurchase ? (
                            <>
                                <Text bold={true}>
                                    {textPaper('(Tebus Murah) ' + productName, jml_paper)}
                                </Text>
                                <Row
                                    left={
                                        (key.qty || 1) +
                                        (key.product?.product_satuans?.length > 0
                                            ? key.product.product_satuans[0].satuan
                                            : 'pcs') +
                                        " x " +
                                        currencyFormatPrint(price)
                                    }
                                    right={currencyFormatPrint(subtotal)}
                                />
                            </>
                        ) : isClearance ? (
                            <>
                                <Text bold={true}>
                                    {textPaper('(Clearance) ' + productName, jml_paper)}
                                </Text>
                                <Row
                                    left={
                                        (key.qty || 1) +
                                        (key.product?.product_satuans?.length > 0
                                            ? key.product.product_satuans[0].satuan
                                            : 'pcs') +
                                        " x " +
                                        currencyFormatPrint(price)
                                    }
                                    right={currencyFormatPrint(subtotal)}
                                />
                            </>
                        ) : (
                            key.status_bonus !== undefined && key.status_bonus !== null ? (
                                key.status_bonus === true ? (
                                    <>
                                        <Text bold={true}>
                                            {'(Bonus) ' + productName}
                                        </Text>
                                        <Row
                                            left={
                                                key.qty +
                                                (key.product.product_satuans.length > 0 ? key.product.product_satuans[0].satuan : '') +
                                                " x " +
                                                currencyFormatPrint(0)
                                            }
                                            right={currencyFormatPrint(0)}
                                        />
                                    </>
                                ) : null
                            ) : (
                                <>
                                    <Text bold={true}>{textPaper(productName, jml_paper)}</Text>
                                    <Row
                                        left={
                                            key.qty +
                                            (key.product.product_satuans.length > 0 ? key.product.product_satuans[0].satuan : '') +
                                            " x " +
                                            currencyFormatPrint(price_normal)
                                        }
                                        right={currencyFormatPrint(subtotal)}
                                    />

                                    {Number(discount_price) > 0 && (
                                        <Row
                                            left="Diskon"
                                            right={currencyFormatPrint(discount_price) + '(' + discount_percent + '%)'}
                                        />
                                    )}

                                    {key.bonus !== undefined && key.bonus !== null ? (
                                        key.qty >= key.bonus.min_order ? (
                                            key.bonus.bonus_product !== null ? (
                                                <>
                                                    <Text bold={true}>
                                                        {'(Bonus) ' + key.bonus.bonus_product.variant_product.product.product_name + ' ' + key.bonus.bonus_product.variant_product.variant_name}
                                                    </Text>
                                                    <Row
                                                        left={
                                                            bonusPCS(key) +
                                                            (key.bonus.bonus_product.variant_product.product.product_satuan !== null
                                                                ? key.bonus.bonus_product.variant_product.product.product_satuan.satuan
                                                                : '') +
                                                            " x " +
                                                            currencyFormatPrint(0)
                                                        }
                                                        right={currencyFormatPrint(0)}
                                                    />
                                                </>
                                            ) : null
                                        ) : null
                                    ) : null}
                                </>
                            )
                        )}

                        {ev.product.length < (i + 1) && <Br />}
                    </div>
                );
            })}

            <Line />
            <Text size={{ width: 1.1, height: 1.1 }} bold={true} align="right">
                Total : {currencyFormatPrint(Number(ev.data.grand_total))}
            </Text>
            <Text bold={true} align="right">+ Termasuk Pajak</Text>
            <Line />
            <Text size={{ width: 1, height: 1 }} bold={true} align="center">
                ANDA HEMAT {currencyFormatPrint(total_disc_price)}
            </Text>
            <Line />

            {ev.data.payment_method === 'tunai' ? (
                <Row left="TUNAI : " right={currencyFormatPrint(ev.data.payment)} />
            ) : ev.data.payment_method === 'tunai_point' || ev.data.payment_method === 'point' ? (
                <>
                    <Row left="POINT : " right={"-" + currencyFormatPrint(ev.data.point_redeem)} />
                    <Row left="TUNAI : " right={currencyFormatPrint(ev.data.payment)} />
                </>
            ) : ev.data.payment_method === 'card_point' ? (
                <>
                    <Row left="POINT : " right={"-" + currencyFormatPrint(ev.data.point_redeem)} />
                    <Row left={ev.data.payment_name + ' :'} right={currencyFormatPrint(ev.data.payment)} />
                </>
            ) : (
                <Row left={ev.data.payment_name + ' :'} right={currencyFormatPrint(ev.data.grand_total)} />
            )}

            {ev.data.voucher_price !== null && Number(ev.data.voucher_price) !== 0 ? (
                <Row left={'Voucher :'} right={currencyFormatPrint(ev.data.voucher_price)} />
            ) : null}

            <Line />
            <Row left="Kembali : " right={currencyFormatPrint(ev.data.cashback)} />
            <Line />
            <Row left="DPP : " right={currencyFormatPrint((ev.data.grand_total / 1.11))} />
            <Row left="Tax : " right={currencyFormatPrint(((ev.data.grand_total / 1.11) * 0.11))} />
            <Line />
            <Text align="center">Barang yang sudah dibeli tidak</Text>
            <Text align="center">bisa ditukar / dikembalikan</Text>
            <Line />
            <Text align="center">Website : www.boldestore.com</Text>
            <Line />

            {ev.transaction.code_draw !== null && (
                <>
                    <Text bold={true} align="center">KODE UNDIAN</Text>
                    <QRCode align="center" content={ev.transaction.link_qrcode} model="model2" cellSize={8} correction="L" />
                    <Br />
                    <Text align="center">{ev.transaction.code_draw}</Text>
                </>
            )}

            <Cut />
        </Printer>
    );

    const data = await render(receipt);
    const w = serialPort.writable?.getWriter();

    if (w != null) {
        await w.write(data);
        w.releaseLock();
    }
};

export const writePrintHistory = async (serialPort, ev) => {
    var dt = new Date(ev.product.created_at);
    var dateTime = dateFormat(dt);
    var customer = ev.customer !== undefined && ev.customer !== null ? ev.customer.name : 'Non Membership';
    var total_disc_price = 0;

    const receipt = (
        <Printer type="epson" width={jml_paper}>
            <Image align="center" src={ev.outlet.image != null ? ev.outlet.image : "assets/bolde2.png"} />
            <Text align="center">PT. BOLDE INOVASI GLOBAL</Text>
            <Text align="center">Komp Taman Palem Lestari J/28A, Cengkareng, Jakarta Barat</Text>
            <Text align="center">NPWP : 02.456.139.1-034.000</Text>
            <Br />
            <Text size={{ width: 1, height: 1 }} bold={true} align="center">{textPaper(ev.outlet.outlet_name, jml_paper)}</Text>
            <Text align="center">{ev.outlet.address !== "" && ev.outlet.address !== null ? textPaper(ev.outlet.address, jml_paper) : "Komp Era Prima No G1 Jl Daan Mogot KM 21, Tangerang"}</Text>
            <Text bold={true} align="center">{ev.product.transaction_code}</Text>
            <Br />

            {ev.product.is_ecommerce === true ? (
                <>
                    <Line />
                    <Text align="center">E-Commerce</Text>
                    <Line />
                </>
            ) : (
                <Line />
            )}

            <Text align="center">CETAK ULANG</Text>
            <Line />
            <Row left="Kasir     : " right={textRight(ev.cashier.detail_user.first_name + ' ' + ev.cashier.detail_user.last_name)} />
            <Row left="Transaksi : " right={dateTime} />
            <Row left="Pelanggan : " right={textRight(customer)} />
            <Line />

            {ev.product.transaction_products.map((key, i) => {
                const isMinPurchase =
                    key.is_min_purchase === true ||
                    key.is_min_purchase === 1 ||
                    key.is_min_purchase === '1' ||
                    key.is_min_purchase === 'true';

                const isClearance =
                    key.is_clearance === true ||
                    key.is_clearance === 1 ||
                    key.is_clearance === '1' ||
                    key.is_clearance === 'true';

                const qty = Number(key.qty || 1);

                const minPurchasePrice =
                    Number(key.price || 0) > 0
                        ? Number(key.price)
                        : Number(key.subtotal || 0) / qty;

                const clearancePrice =
                    Number(key.price || 0) > 0
                        ? Number(key.price)
                        : Number(key.subtotal || 0) / qty;

                var price = isMinPurchase
                    ? minPurchasePrice
                    : isClearance
                        ? clearancePrice
                        : key.discount !== null
                            ? Number(key.discount.price_after_discount)
                            : Number(key.price || 0);

                var discount_percent = (isMinPurchase || isClearance)
                    ? null
                    : key.discount !== null
                        ? Number(key.discount.discount_percent) + "%"
                        : 0;

                var discount_price = (isMinPurchase || isClearance)
                    ? 0
                    : key.discount !== null
                        ? Number(key.discount.discount_price || 0)
                        : 0;

                var price_normal = (isMinPurchase || isClearance)
                    ? price
                    : Number(price) + Number(discount_price);

                var subtotal = (isMinPurchase || isClearance)
                    ? Number(key.subtotal || (price * qty))
                    : price_normal * qty;

                total_disc_price += Number(discount_price || 0) * qty;

                var productName =
                    (key.product?.product_name || '-') +
                    ' ' +
                    (key.variant_product?.variant_name || '');

                return (
                    <div key={i}>
                        {isMinPurchase ? (
                            <>
                                <Text bold={true}>
                                    {textPaper('(Tebus Murah) ' + productName, jml_paper)}
                                </Text>
                                <Row
                                    left={
                                        qty +
                                        (key.product?.product_satuans?.length > 0
                                            ? key.product.product_satuans[0].satuan
                                            : 'pcs') +
                                        " x " +
                                        currencyFormatPrint(price)
                                    }
                                    right={currencyFormatPrint(subtotal)}
                                />
                            </>
                        ) : isClearance ? (
                            <>
                                <Text bold={true}>
                                    {textPaper('(Clearance) ' + productName, jml_paper)}
                                </Text>
                                <Row
                                    left={
                                        qty +
                                        (key.product?.product_satuans?.length > 0
                                            ? key.product.product_satuans[0].satuan
                                            : 'pcs') +
                                        " x " +
                                        currencyFormatPrint(price)
                                    }
                                    right={currencyFormatPrint(subtotal)}
                                />
                            </>
                        ) : (
                            key.status_bonus !== undefined && key.status_bonus !== null ? (
                                key.status_bonus === true ? (
                                    <>
                                        <Text bold={true}>{'(Bonus) ' + productName}</Text>
                                        <Row
                                            left={
                                                qty +
                                                (key.product?.product_satuans?.length > 0
                                                    ? key.product.product_satuans[0].satuan
                                                    : '') +
                                                " x " +
                                                currencyFormatPrint(0)
                                            }
                                            right={currencyFormatPrint(0)}
                                        />
                                    </>
                                ) : null
                            ) : (
                                <>
                                    <Text bold={true}>{textPaper(productName, jml_paper)}</Text>
                                    <Row
                                        left={
                                            qty +
                                            (key.product?.product_satuans?.length > 0
                                                ? key.product.product_satuans[0].satuan
                                                : '') +
                                            " x " +
                                            currencyFormatPrint(price_normal)
                                        }
                                        right={currencyFormatPrint(subtotal)}
                                    />

                                    {Number(discount_price) > 0 && (
                                        <Row
                                            left="Diskon"
                                            right={currencyFormatPrint(discount_price) + '(' + discount_percent + ')'}
                                        />
                                    )}

                                    {key.bonus !== undefined && key.bonus !== null ? (
                                        key.qty >= key.bonus.min_order ? (
                                            key.bonus.bonus_product !== null ? (
                                                <>
                                                    <Text bold={true}>
                                                        {'(Bonus) ' +
                                                            key.bonus.bonus_product.variant_product.product.product_name +
                                                            ' ' +
                                                            (key.bonus.bonus_product.variant_product.variant_name !== null
                                                                ? key.bonus.bonus_product.variant_product.variant_name
                                                                : '')}
                                                    </Text>
                                                    <Row
                                                        left={
                                                            bonusPCS(key) +
                                                            (key.bonus.bonus_product.variant_product.product.product_satuan !== null
                                                                ? key.bonus.bonus_product.variant_product.product.product_satuan.satuan
                                                                : '') +
                                                            " x " +
                                                            currencyFormatPrint(0)
                                                        }
                                                        right={currencyFormatPrint(0)}
                                                    />
                                                </>
                                            ) : null
                                        ) : null
                                    ) : null}
                                </>
                            )
                        )}

                        {ev.product.transaction_products.length < (i + 1) && <Br />}
                    </div>
                );
            })}

            <Line />
            <Text size={{ width: 1.1, height: 1.1 }} bold={true} align="right">
                Total : {currencyFormatPrint(Number(ev.product.grand_total))}
            </Text>
            <Text bold={true} align="right">+ Termasuk Pajak</Text>
            <Line />
            <Text size={{ width: 1, height: 1 }} bold={true} align="center">
                ANDA HEMAT {currencyFormatPrint(total_disc_price)}
            </Text>
            <Line />

            {ev.payment_method === 'tunai' ? (
                <Row left="TUNAI : " right={currencyFormatPrint(ev.product.payment)} />
            ) : ev.payment_method === 'tunai_point' || ev.payment_method === 'point' ? (
                <>
                    <Row left="POINT : " right={"-" + currencyFormatPrint(ev.product.point_redeem)} />
                    <Row left="TUNAI : " right={currencyFormatPrint(ev.product.payment)} />
                </>
            ) : ev.payment_method === 'card_point' ? (
                <>
                    <Row left="POINT : " right={"-" + currencyFormatPrint(ev.product.point_redeem)} />
                    <Row left={ev.product.device_payment + ' :'} right={currencyFormatPrint(ev.product.grand_total)} />
                </>
            ) : (
                <Row left={ev.product.device_payment + ' :'} right={currencyFormatPrint(ev.product.grand_total)} />
            )}

            {ev.product.voucher_price !== null && Number(ev.product.voucher_price) !== 0 ? (
                <Row left={'Voucher :'} right={currencyFormatPrint(ev.product.voucher_price)} />
            ) : null}

            <Line />
            <Row left="Kembali : " right={currencyFormatPrint(ev.product.payment - ev.product.grand_total)} />
            <Line />
            <Row left="DPP : " right={currencyFormatPrint((ev.product.grand_total / 1.11))} />
            <Row left="Tax : " right={currencyFormatPrint(((ev.product.grand_total / 1.11) * 0.11))} />
            <Line />
            <Text align="center">Barang yang sudah dibeli tidak</Text>
            <Text align="center">bisa ditukar / dikembalikan</Text>
            <Line />
            <Text align="center">Website : www.boldestore.com</Text>
            <Line />

            {ev.product.code_draw !== null && (
                <>
                    <Text bold={true} align="center">KODE UNDIAN</Text>
                    <QRCode align="center" content={ev.product.link_qrcode} model="model2" cellSize={8} correction="L" />
                    <Br />
                    <Text align="center">{ev.product.code_draw}</Text>
                </>
            )}

            <Cut />
        </Printer>
    );

    const data = await render(receipt);
    const w = serialPort.writable?.getWriter();

    if (w != null) {
        await w.write(data);
        w.releaseLock();
    }
};

export const writePrintReturn = async (serialPort, ev) => {
    var date = new Date();
    var dateTime = dateFormat(date);
    var customer = ev.transaction.customer !== undefined && ev.transaction.customer !== null ? ev.transaction.customer.name : 'Non Membership';
    var total = 0;
    var total_qty = 0;
    var transCode = ev.return_code !== null ? ev.return_code : ev.transaction_code;
    const receipt = (
        <Printer type="epson" width={jml_paper}>
            <Image align="center" src={ev.outlet.image != null ? ev.outlet.image : "assets/bolde2.png"} />
            <Text align="center">PT. BOLDE INOVASI GLOBAL</Text>
            <Text align="center">Komp Taman Palem Lestari J/28A, Cengkareng, Jakarta Barat</Text>
            <Text align="center">NPWP : 02.456.139.1-034.000</Text>
            <Br />
            <Text size={{ width: 1, height: 1 }} bold={true} align="center">{textPaper(ev.outlet.outlet_name, jml_paper)}</Text>
            <Text align="center">{ev.outlet.address !== "" && ev.outlet.address !== null ? textPaper(ev.outlet.address, jml_paper) : "Komp Era Prima No G1 Jl Daan Mogot KM 21, Tangerang"}</Text>
            <Text bold={true} align="center">{transCode}</Text>
            <Br />
            <Line />
            <Text align="center">RETUR TRANSAKSI</Text>
            <Line />
            <Row left="Diretur   : " right={textRight(ev.transaction.user.detail_user.first_name + ' ' + ev.transaction.user.detail_user.last_name)} />
            <Row left="Transaksi : " right={dateTime} />
            <Row left="Pelanggan : " right={textRight(customer)} />
            <Line />
            {
                ev.product_returns.map((key, i) => {
                    total_qty += Number(key.qty);
                    total += Number(key.subtotal);
                    var productName = key.product.product_name;
                    var price = key.discount !== null ? key.discount.price_after_discount : key.price;
                    var discount_percent = key.discount !== null ? Number(key.discount.discount_percent) + "%" : 0;
                    var discount_price = key.discount !== null ? key.discount.discount_price : 0;

                    return (
                        <div key={i}>
                            <>
                                <Text bold={true}>{textPaper(productName, jml_paper)}</Text>
                                <Row left={key.qty + (key.product.product_satuans.length > 0 ? key.product.product_satuans[0].satuan : '') + " x " + currencyFormatPrint(price)} right={currencyFormatPrint(key.subtotal)} />
                                <Row left="Diskon" right={currencyFormatPrint(discount_price) + '(' + discount_percent + ')'} />
                            </>
                            {ev.product_returns.length < (i + 1) && <Br />}
                        </div>
                    )
                })
            }
            <Line />
            <Row left="Total Barang Kembali : " right={total_qty.toString()} />
            <Line />
            {
                Number(ev.voucher_num) > 0 &&
                <>
                    <Row left="Voucher Kembali : " right={formatNumber(ev.voucher_num)} />
                    <Line />
                </>
            }
            {
                Number(ev.point_redeem) > 0 &&
                <>
                    <Row left="Point Redeem Kembali : " right={formatNumber(ev.point_redeem)} />
                    <Line />
                </>
            }
            <Text size={{ width: 1.1, height: 1.1 }} bold={true} align="right" >Dikembalikan : {currencyFormatPrint(total - Number(ev.voucher_num))}</Text>
            <Line />
            <Text align="center">Barang yang sudah dibeli tidak</Text>
            <Text align="center">bisa ditukar / dikembalikan</Text>
            <Line />
            <Text align="center">Website : www.boldestore.com</Text>
            <Cut />
        </Printer>
    );
    const data = await render(receipt);
    const w = serialPort.writable?.getWriter();
    if (w != null) {
        await w.write(data);
        w.releaseLock();
    }
}

export const writePrintDailyReport = async (
    serialPort,
    dataTotalTransaction,
    dataOutlet
) => {
    const now = dateFormat(new Date());

    const totalTunai = Number(dataTotalTransaction?.total_tunai?.total || 0);
    const totalEdcBca = Number(dataTotalTransaction?.total_edc_bca?.total || 0);
    const totalEdcBri = Number(dataTotalTransaction?.total_edc_bri?.total || 0);
    const totalEdcMandiri = Number(dataTotalTransaction?.total_edc_mandiri?.total || 0);
    const totalEdcKredivo = Number(dataTotalTransaction?.total_edc_kredivo?.total || 0);
    const totalVoucher = Number(dataTotalTransaction?.total_voucher?.total || 0);

    const totalPendapatan =
        totalTunai +
        totalEdcBca +
        totalEdcBri +
        totalEdcMandiri +
        totalEdcKredivo;

    const totalTransaksi = dataOutlet.reduce(
        (sum, item) => sum + (item.transactions?.length || 0),
        0
    );

    const receipt = (
        <Printer type="epson" width={jml_paper}>
            <Text bold align="center">
                LAPORAN HARIAN OUTLET
            </Text>

            <Text align="center">{now}</Text>

            <Line />

            <Row
                left="Total Transaksi"
                right={`${totalTransaksi}`}
            />

            <Row
                left="Tunai"
                right={currencyFormatPrint(totalTunai)}
            />

            <Row
                left="EDC BCA"
                right={currencyFormatPrint(totalEdcBca)}
            />

            <Row
                left="EDC BRI"
                right={currencyFormatPrint(totalEdcBri)}
            />

            <Row
                left="EDC Mandiri"
                right={currencyFormatPrint(totalEdcMandiri)}
            />

            <Row
                left="EDC Kredivo"
                right={currencyFormatPrint(totalEdcKredivo)}
            />

            <Row
                left="Voucher"
                right={currencyFormatPrint(totalVoucher)}
            />

            <Line />

            <Text bold align="right">
                TOTAL PENJUALAN
            </Text>

            <Text
                bold
                size={{ width: 1, height: 1 }}
                align="right"
            >
                {currencyFormatPrint(totalPendapatan)}
            </Text>

            <Line />

            <Text bold align="center">
                DETAIL OUTLET
            </Text>

            <Line />

            {dataOutlet.map((item, index) => {
                const totalOutlet =
                    item.transactions?.reduce(
                        (sum, trx) => sum + Number(trx.grand_total || 0),
                        0
                    ) || 0;

                return (
                    <div key={index}>
                        <Text bold>
                            {item.outlet_name}
                        </Text>

                        <Row
                            left={`${item.transactions?.length || 0} trx`}
                            right={currencyFormatPrint(totalOutlet)}
                        />

                        <Text>
                            Status : {item.isClosed ? "Tutup" : "Buka"}
                        </Text>

                        <Line />
                    </div>
                );
            })}

            <Text align="center">
                --- END REPORT ---
            </Text>

            <Cut />
        </Printer>
    );

    const data = await render(receipt);

    const writer = serialPort.writable?.getWriter();

    if (writer) {
        await writer.write(data);
        writer.releaseLock();
    }
};